const environmentDetails = process.env.REACT_APP_B2C_ENVIRONMENTDETAILS

export const scopes = {
  bookings: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/bookings-api/Bookings.All`,
  travelPolicies: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/travelPolicies-api/TravelPolicies.All`,
  taxis: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/taxis-api/Taxis.All`,
  taxisRates: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/taxiRates-api/TaxiRates.All`,
  suppliers: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/suppliers-api/Suppliers.All`,
  supplierOperations: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/supplierOperations-api/SupplierOperations.All`,
  driverLocations: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/driverLocations-api/DriverLocations.All`,
  congestionZones: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/congestionZones-api/CongestionZones.All`,
  clients: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/clients-api/Clients.All`,
  chargeExceptions: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/chargeExceptions-api/ChargeExceptions.All`,
  quotes: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/quotes-api/Quotes.All`,
  locationServices: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/locationServices-api/LocationServices.All`,
  users: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/users-api/Users.All`,
  supplierGroups: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/supplierGroups-api/SupplierGroups.All`,
  platforms: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/platforms-api/Platforms.All`,
  flights: `https://jyrneyb2c${environmentDetails}.onmicrosoft.com/flights-api/Flights.All`,
}

export type tokenScope =
  | 'bookings'
  | 'travelPolicies'
  | 'taxis'
  | 'taxisRates'
  | 'suppliers'
  | 'supplierOperations'
  | 'driverLocations'
  | 'congestionZones'
  | 'clients'
  | 'chargeExceptions'
  | 'quotes'
  | 'locationServices'
  | 'users'
  | 'supplierGroups'
  | 'platforms'
  | 'flights'
